export const pharmacies = {
  hero: {
    title: "Contabilidad Especializada y Gestión Financiera para Farmacias",
    subtitle: "Servicios financieros compatibles con HIPAA diseñados específicamente para farmacias independientes, cadenas de farmacias e instalaciones de preparación magistral",
    cta: "Programar Consulta Gratuita",
    learnMore: "Más Información"
  },
  services: {
    title: "Servicios Financieros Integrales para Farmacias",
    subtitle: "Desde el seguimiento de ingresos por recetas hasta el cumplimiento de la DEA, manejamos todos los aspectos de la gestión financiera de su farmacia",
    items: [
      {
        title: "Gestión de Ingresos por Recetas",
        description: "Rastree y concilie todas las ventas de recetas por tipo de pagador (efectivo, seguro, Medicare/Medicaid) con coincidencia automatizada de depósitos"
      },
      {
        title: "Reconciliación de Seguros y PBM",
        description: "Coincida reclamos de seguros, adjudicaciones y tarifas DIR con reconciliación integral de pagadores de terceros"
      },
      {
        title: "Seguimiento de Inventario y COGS",
        description: "Gestión de inventario perpetuo con costeo FIFO/WAC, seguimiento genérico vs marca, y procesamiento de devoluciones/créditos"
      },
      {
        title: "Cumplimiento de Sustancias Controladas",
        description: "Reconciliación DEA Schedule II-V y preparación de auditorías con seguimiento detallado de sustancias controladas"
      },
      {
        title: "Informes de Cumplimiento Regulatorio",
        description: "Informes de cumplimiento de la Junta Estatal, DEA y FDA con seguimiento automatizado de tarifas regulatorias"
      },
      {
        title: "Análisis Financiero e Informes",
        description: "P&L mensual, análisis de flujo de efectivo e informes de métricas clave de farmacia para toma de decisiones informada"
      }
    ]
  },
  tracking: {
    title: "Lo Que Rastreamos para Su Farmacia",
    subtitle: "Manejamos cada detalle para que se mantenga en cumplimiento, listo para auditorías y enfocado en la atención al paciente.",
    items: [
      {
        title: "Ingresos por Recetas",
        description: "Rastree y concilie todas las ventas de recetas y depósitos por pagador: efectivo, seguro, Medicare/Medicaid"
      },
      {
        title: "Ventas OTC y Servicios de Inmunización",
        description: "Registre ingresos de productos de mostrador y servicios clínicos"
      },
      {
        title: "Gestión de Inventario",
        description: "Seguimiento de inventario perpetuo (FIFO/WAC), genérico vs marca, y devoluciones/créditos"
      },
      {
        title: "Sustancias Controladas",
        description: "Reconciliación DEA Schedule II–V y preparación de auditorías"
      },
      {
        title: "Reconciliación de Terceros/PBM",
        description: "Coincida reclamos de seguros y PBM, adjudicaciones, tarifas DIR"
      },
      {
        title: "Cuentas por Cobrar",
        description: "Monitoree cuentas por cobrar de seguros, pacientes y Medicare Parte D"
      },
      {
        title: "Gastos Operativos",
        description: "Rastree nómina, alquiler, servicios públicos, licencias, seguros y software"
      },
      {
        title: "Costos de Cumplimiento",
        description: "Tarifas regulatorias separadas (DEA, Junta Estatal)"
      }
    ]
  },
  benefits: {
    title: "Por Qué las Farmacias Eligen LedgRkeepR",
    subtitle: "Experiencia especializada en operaciones de farmacia y cumplimiento regulatorio",
    items: [
      {
        title: "Experiencia en Cumplimiento HIPAA",
        description: "Cumplimiento completo de HIPAA con manejo seguro de datos y pistas de auditoría para todos los datos financieros relacionados con pacientes"
      },
      {
        title: "Conocimiento Regulatorio",
        description: "Comprensión profunda de los requisitos de DEA, FDA y Junta Estatal con monitoreo proactivo de cumplimiento"
      },
      {
        title: "Informes Específicos de la Industria",
        description: "Informes financieros enfocados en farmacias incluyendo análisis de volumen de recetas y optimización de mezcla de pagadores"
      },
      {
        title: "Preparación de Auditorías",
        description: "Siempre listo para auditorías con documentación organizada para inspecciones de DEA, seguros y regulatorias"
      }
    ]
  },
  testimonials: {
    title: "Lo Que Dicen los Propietarios de Farmacias",
    items: [
      {
        name: "Dra. Sarah Chen",
        role: "Propietaria, Community Care Pharmacy",
        quote: "LedgRkeepR transformó nuestra gestión financiera. Su experiencia en farmacias nos salvó durante nuestra auditoría de la DEA.",
        rating: 5
      },
      {
        name: "Michael Rodriguez, PharmD",
        role: "Propietario, Rodriguez Family Pharmacy",
        quote: "Finalmente, contabilidad que entiende la reconciliación de PBM y el seguimiento de sustancias controladas. Altamente recomendado.",
        rating: 5
      },
      {
        name: "Dra. Jennifer Walsh",
        role: "Propietaria, Wellness Compounding Pharmacy",
        quote: "Sus procesos compatibles con HIPAA y experiencia regulatoria me dan completa tranquilidad.",
        rating: 5
      }
    ]
  },
  cta: {
    title: "¿Listo para Optimizar la Gestión Financiera de Su Farmacia?",
    subtitle: "Únase a cientos de propietarios de farmacias que confían en LedgRkeepR para sus necesidades financieras",
    primaryButton: "Programar Consulta Gratuita",
    secondaryButton: "Descargar Guía de Farmacia"
  }
};